import React from 'react';
import styled from './index._less';
import RegLayer from '../../../components/RegLayer';
import LoginAgreement from '../../../components/LoginAgreement';

export default () => {

  return (
    <>
      <div className="right-content">
        {/* 登录内容区 */}
        <div className="login-content">
          <RegLayer />
        </div>
        {/* 登录底部 */}
        <LoginAgreement />
      </div>
      <style jsx>{styled}</style>
    </>
  )
}
